'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/* eslint no-undef: "off" */
/**
 * stores app
 */
define('storeViewMain',['util', 'getStoresListApi', 'storeProductsListApi', 'baseSlider', 'bottomSheet', 'svgIcon', 'busEvent', 'xparkProductCard', 'addToCartApi', 'selectSpecModal', 'GAReport'], function (Util, getStoresListApi, storeProductsListApi, baseSlider, bottomSheet, svgIcon, busEvent, xparkProductCard, addToCartApi, selectSpecModal, GAReport) {
  return {
    template: '\n        <div class="page-container store-view" v-infinite-scroll="loadMoreProducts" infinite-scroll-disabled="loadingMore || isLastPage" infinite-scroll-distance="1">\n              <div class="store-item">\n                  <div class="store-info-container">\n                      <div class="tags" v-if="store.tags && store.tags.length > 0">\n                          <div class="tag-item" v-for="(v, idx) in store.tags">{{v}}</div>\n                      </div>\n                      <div class="store-name" v-text="store.title"></div>\n                      <div class="store-star" v-if="store.score && store.score > 0">\n                          <div class="star-wrapper">\n                            <div class="dark-box">\n                                <i class="xparkFonts icon-wujiaoxing" />\n                                <i class="xparkFonts icon-wujiaoxing" />\n                                <i class="xparkFonts icon-wujiaoxing" />\n                                <i class="xparkFonts icon-wujiaoxing" />\n                                <i class="xparkFonts icon-wujiaoxing" />\n                            </div>\n                            <div class="light-box" :style="{ width: (store.score / 5 * 100) + \'%\' }">\n                                <i class="xparkFonts icon-wujiaoxing" />\n                                <i class="xparkFonts icon-wujiaoxing" />\n                                <i class="xparkFonts icon-wujiaoxing" />\n                                <i class="xparkFonts icon-wujiaoxing" />\n                                <i class="xparkFonts icon-wujiaoxing" />\n                            </div>\n                          </div>\n                          <span class="score-wrapper" v-text="store.score"></span>\n                          <!--<span class="comment-count">(48)</span>-->\n                      </div>\n                      <div class="store-info">\n                          <div class="info-content">\n                              <div class="icon">\n                                  <i class="xparkFonts icon-shijian" />\n                              </div>\n                              <div class="content" v-text="store.work_time"></div>\n                          </div>\n                          <div class="info-content">\n                              <div class="icon">\n                                  <i class="xparkFonts icon-dingwei" />\n                              </div>\n                              <div class="content address-content">\n                                  <div class="address">\n                                      {{store.address}} ,{{store.city_name}}, {{store.country_name}}\n                                  </div>\n                                  <div class="distance">{{ (store.distance || 0).toFixed(2) }}km</div>\n                              </div>\n                          </div>\n                      </div>\n                  </div>\n                  <div class="store-info-action">\n                      <div class="actions">\n                          <a target="_blank" :href="store.nav_link"><i class="xparkFonts icon-dingwei1" /></a>\n                          <a v-if="store.phone" :href="store.tel_link"><i class="xparkFonts icon-dianhua" /></a>\n                          <a v-if="store.whatsapp" target="_blank" :href="store.whatsapp"><img :src="require.toUrl(\'images/whatsapp.svg\')" /></a>\n                      </div>\n                  </div>\n             </div>\n             <div class="store-information">\n                  <div class="title">\n                      <span v-text="i18n.onSaleProducts"></span>\n                      <div class="actions">\n                          <div class="action-btn" @click="handleSetModal(\'Sort\')">\n                              <img :src="require.toUrl(\'images/sort.svg\')" />\n                          </div>\n<!--                          <div class="action-btn" @click="handleSetModal(\'Filter\')">-->\n<!--                              <img :src="require.toUrl(\'images/filter.svg\')" />-->\n<!--                          </div>-->\n                      </div>\n                  </div>\n<!--                  <div class="banner-container">-->\n<!--                    <base-slider :sliderConfig="sliderConfig">-->\n<!--                          <div class="swiper-slide"><img src="https://global.pro.infinixmobility.com/media/homeblock/X6861_still.jpg" /></div>-->\n<!--                          <div class="swiper-slide"><img src="https://global.pro.infinixmobility.com/media/homeblock/X6861_still.jpg" /></div>-->\n<!--                          <div class="swiper-slide"><img src="https://global.pro.infinixmobility.com/media/homeblock/X6861_still.jpg" /></div>-->\n<!--                          <div class="swiper-slide"><img src="https://global.pro.infinixmobility.com/media/homeblock/X6861_still.jpg" /></div>-->\n<!--                    </base-slider>-->\n<!--                  </div>-->\n\n                  <div class="products-container">\n                      <div class="xp-product-grid" v-if="productsList.length">\n                        <xpark-product-card\n                          v-for="item in productsList"\n                          :key="\'vertical-\' + item.title + item.price"\n                          :product="item"\n                          @cart-click="handleCartClick"\n                        ></xpark-product-card>\n                      </div>\n                  </div>\n             </div>\n             <select-spec-modal\n                v-if="plpProductInfo.product_id"\n                :key="plpProductInfo.product_id"\n                :productInfo="plpProductInfo"\n                :use-global-success-modal="true"\n              ></select-spec-modal>\n             <bottom-sheet\n                  :visible="showModal"\n                  :title="showModal"\n                  confirmText="OK"\n                  @close="handleSetModal()"\n                  @confirm="handleModalConfirm">\n                      <div class="xp-select-list" v-if="showModal === \'Sort\'">\n                          <button\n                              type="button"\n                              class="xp-select-row"\n                              :class="{active: item.code === selectCurrentSortBy}"\n                              v-for="item in sortList"\n                              @click="handleSetSelect(item)">\n                                  <span class="xp-select-row-label">\n                                      <span v-html="item.label"></span>\n                                  </span>\n                                  <svg-icon v-if="selectCurrentSortBy === item.code" type="check"></svg-icon>\n                          </button>\n                      </div>\n              </bottom-sheet>\n        </div>\n    ',
    data: function data() {
      return {
        i18n: {
          visitStore: "Visit store",
          onSaleProducts: "On-sale Products"
        },
        map: null,
        store: {},
        lat: 0,
        lng: 0,
        loading: false,
        // modal
        showModal: null,
        sortList: [],
        currentSortBy: 'position_desc',
        selectCurrentSortBy: 'position_desc',
        // 无限滚动必须加的
        page: 0,
        loadingMore: false,
        isLastPage: false,
        productsList: [],
        // banner
        sliderConfig: {
          isPagination: true,
          isButtonPrev: false,
          isButtonNext: false,
          coreSliderConfig: {
            lazy: true,
            loop: true,
            autoplay: {
              delay: 6000,
              disableOnInteraction: false
            },
            pagination: {
              el: '.swiper-pagination',
              clickable: true
            },
            on: {
              click: function click(e) {}
            }
          }
        },
        plpProductInfo: {}
      };
    },

    components: {
      baseSlider: baseSlider,
      bottomSheet: bottomSheet,
      svgIcon: svgIcon,
      xparkProductCard: xparkProductCard,
      selectSpecModal: selectSpecModal
    },
    mounted: function mounted() {
      var _this = this;

      // 定位
      this.getPosition();
      this.getStoreList();
      this.$nextTick(function () {
        _this.loadMoreProducts();
      });
    },

    computed: {},
    methods: {
      getPosition: function getPosition() {
        var _this2 = this;

        var that = this;
        this.loading = true;
        Util.getCurrentLocation({ enableHighAccuracy: true, timeout: 10000 }).then(function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(position) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    that.lat = position.coords.latitude;
                    that.lng = position.coords.longitude;
                    that.loading = false;

                  case 3:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this2);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }()).catch(function (err) {
          // err.code: 1=PERMISSION_DENIED, 2=POSITION_UNAVAILABLE, 3=TIMEOUT
          if (err.code && (err.code === 2 || err.code === 3)) {
            that.$modal.show('getLocation');
          } else {
            Util.getPositionWithGoogle().then(function (res) {
              that.loading = false;
              if (res.success) {
                that.lat = res.location.lat;
                that.lng = res.location.lng;
              } else {
                that.tipsTitle = that.i18n.locationTitle;
                that.tipsMsg = res.error;
                that.$modal.show('resultTips');
              }
            });
          }
        });
      },
      getStoreList: function getStoreList() {
        var data = window.storesViewJSON;
        if (data && data.data) {
          this.calculatePosition(data.data);
        }
      },
      calculatePosition: function calculatePosition(data) {
        if (this.store || data) {
          var newStore = data || this.store;
          newStore.distance = Util.calculateDistance(newStore.latitude, newStore.longitude, this.lat, this.lng);
          this.store = newStore;
        }
      },


      // ========== 加载更多 ==========
      loadMoreProducts: function loadMoreProducts() {
        var _this3 = this;

        if (!this.loadingMore) {
          this.loadingMore = true;
          this.page += 1;
          storeProductsListApi({
            warehouseId: this.store.warehouse_id,
            page: this.page,
            pageSize: 20,
            sort: this.currentSortBy
          }).then(function (resData) {
            _this3.loadingMore = false;
            if (resData && resData.items && resData.items.length > 0) {
              _this3.productsList = [].concat(_toConsumableArray(_this3.productsList), _toConsumableArray(resData.items));
              _this3.sortList = resData.sorts;
            }
          });
        }
      },

      // ======== 筛选 ========
      handleSetModal: function handleSetModal(name) {
        this.showModal = name || null;
        if (!name) {
          this.selectCurrentSortBy = this.currentSortBy;
        }
      },
      handleSetSelect: function handleSetSelect(data) {
        this.selectCurrentSortBy = data.code;
      },
      handleModalConfirm: function handleModalConfirm() {
        this.currentSortBy = this.selectCurrentSortBy;
        this.showModal = null;
        this.page = 0;
        this.productsList = [];
        this.loadMoreProducts();
      },
      handleCartClick: function handleCartClick(product) {
        var data = this.createProductObj(product);

        if (!data.product_id) {
          return;
        }

        window.productDataJSON = {
          data: data
        };

        if (data.product_type === 'configurable') {
          this.plpProductInfo = data;
          this.$nextTick(function () {
            busEvent.$emit('selectSpecShowEvent', 'addToCart');
          });
          return;
        }

        this.addSimpleProductToCart(data);
      },
      createProductObj: function createProductObj(product) {
        var productType = product.product_type || product.type || (Array.isArray(product.configattr) && product.configattr.length ? 'configurable' : 'simple');
        var productId = product.product_id || product.id || product.item_id;
        var simpleStatus = typeof product.status === 'boolean' ? product.status : product.status === 1 || product.status === '1';
        var simpleMaxSaleQty = product.max_sale_qty || product.max_sale_qty === 0 ? product.max_sale_qty : 0;
        var defaultImages = [product.image || product.imgurl || product.product_image].filter(Boolean);
        var base = {
          product_id: productId,
          product_type: productType,
          status: simpleStatus,
          share_able: product.share_able,
          name: product.title || product.name || product.product_name || '',
          sku: product.sku,
          short_description: product.subtitle || product.short_description || '',
          description: product.description || '',
          price: product.final_price || product.price || 0,
          price_label: product.final_price_label || product.price_label || '',
          origin_price_label: product.origin_price_label || product.max_price_label || '',
          level_price: product.level_price || {},
          defaultImages: defaultImages,
          images: defaultImages,
          new_icon: product.new_icon,
          sale_icon: product.sale_icon,
          spec: product.spec || [],
          usps: product.usps || [],
          timerObj: {},
          block: product.block,
          pre_order_is_join: product.pre_order_is_join,
          is_in_wishlist: product.in_wishlist ? 1 : 0,
          wishlist_item_id: product.wishlist_item_id || 0,
          level: product.level,
          can_direct_shopping: product.can_direct_shopping,
          attachment: product.attachment || {
            option: []
          },
          purchase_method: product.purchase_method,
          xp_product: Number(product.xp_product || 0),
          xp_description: product.xp_description,
          pickUp: product.pick_up,
          product_class: product.product_class,
          brand: product.brand,
          product_series: product.product_series,
          category: product.category,
          item_category: product.item_category,
          item_category1: product.item_category1,
          item_category2: product.item_category2,
          item_category3: product.item_category3,
          item_category4: product.item_category4,
          url_link: product.url_link || product.product_link || product.product_url,
          max_sale_qty: simpleMaxSaleQty
        };

        if (productType === 'configurable') {
          base.images = new Map();
          base.configproduct = product.configproduct || {};
          base.configattr = product.configattr || [];
          base.level_price = this.getConfigLevelPrice(product);
        } else {
          base.configproduct = product.configproduct || [];
          base.configattr = product.configattr || [];
        }

        return base;
      },
      getConfigLevelPrice: function getConfigLevelPrice(data) {
        var attrs = data.configattr || [];
        var products = data.configproduct || {};
        var productId = 0;

        if (attrs.length === 1) {
          productId = attrs[0].options[0] && attrs[0].options[0].product_ids[0];
        } else if (attrs.length > 1) {
          var firstIds = new Set(attrs[0].options[0] && attrs[0].options[0].product_ids || []);
          var secondIds = attrs[1].options[0] && attrs[1].options[0].product_ids || [];
          productId = secondIds.filter(function (id) {
            return firstIds.has(id);
          })[0];
        }

        return productId && products['key_' + productId] ? products['key_' + productId].level_price : {};
      },
      addSimpleProductToCart: function addSimpleProductToCart(data) {
        var tmpArr = [];
        tmpArr.id = data.product_id;
        tmpArr.qty = 1;

        addToCartApi({
          data: window.serialize(tmpArr)
        }).then(function () {
          busEvent.$emit('modalSuccess', 'Added to cart successfully');
        });
      }
    },
    watch: {
      lat: function lat(val) {
        if (val) {
          this.calculatePosition();
        }
      }
    }
  };
});
